import { render, staticRenderFns } from "./Ficha.vue?vue&type=template&id=125b5c39"
import script from "./Ficha.vue?vue&type=script&lang=js"
export * from "./Ficha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports